(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hob-home"] && !Shopify.designMode) return;
  try {
    
function initializeHobHome(root) {
  root.querySelectorAll('[data-hob-carousel]').forEach((carousel) => {
    if (carousel.dataset.hobReady) return;
    carousel.dataset.hobReady = 'true';
    const slides = Array.from(carousel.querySelectorAll('[data-hob-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-hob-dot]'));
    const status = carousel.querySelector('[data-hob-status]');
    const controls = carousel.querySelector('[data-hob-controls]');
    let current = 0;
    let touchStart = null;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
      if (status) status.textContent = slides[current].getAttribute('aria-label');
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    carousel.querySelector('[data-hob-prev]').addEventListener('click', () => show(current - 1));
    carousel.querySelector('[data-hob-next]').addEventListener('click', () => show(current + 1));
    carousel.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const destination = event.key === 'ArrowRight' ? current + 1 : current - 1;
      show(destination);
      dots[current].focus();
    });
    carousel.addEventListener('touchstart', (event) => {
      if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (!touchStart || event.changedTouches.length !== 1) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    carousel.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    if (controls) controls.hidden = false;
  });
}
initializeHobHome(document);
document.addEventListener('shopify:section:load', (event) => initializeHobHome(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-photo-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-photo-form]');
    if (!form) return;
    const fileInput = form.elements.photo;
    const button = form.querySelector('[data-submit]');
    const buttonText = button.innerHTML;
    const error = form.querySelector('[data-form-error]');
    const progress = form.querySelector('[data-photo-progress]');
    const preview = form.querySelector('[data-preview]');
    let imageBlob = null;
    let previewUrl = null;
    let processing = null;
    let selection = 0;
    let busy = false;
    let session = null;
    const clearPreview = () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = null;
      preview.hidden = true;
      form.querySelector('[data-upload-symbol]').hidden = false;
      form.querySelector('[data-upload-empty]').hidden = false;
    };
    const showError = text => { error.textContent = text; error.hidden = false; };
    const prepare = async file => {
      if (!file || !['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 20 * 1024 * 1024) throw new Error(root.dataset.photoError);
      let picture;
      try { picture = await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch { throw new Error(root.dataset.decodeError); }
      if (picture.width < 300 || picture.height < 300 || picture.width * picture.height > 80000000) { picture.close(); throw new Error(root.dataset.sizeError); }
      const scale = Math.min(1, 2400 / Math.max(picture.width, picture.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(picture.width * scale);
      canvas.height = Math.round(picture.height * scale);
      if (canvas.width < 300 || canvas.height < 300) { picture.close(); throw new Error(root.dataset.sizeError); }
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#f2eedf'; ctx.fillRect(0,0,canvas.width,canvas.height);
      ctx.drawImage(picture,0,0,canvas.width,canvas.height); picture.close();
      const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',.9));
      if (!blob || blob.size > 5 * 1024 * 1024) throw new Error(root.dataset.fileError);
      return blob;
    };
    fileInput.addEventListener('change', () => {
      const current = ++selection;
      imageBlob = null; session = null;
      fileInput.setCustomValidity(''); error.hidden = true;
      clearPreview(); progress.textContent = root.dataset.processing;
      processing = prepare(fileInput.files[0]).then(blob => {
        if (current !== selection) return;
        imageBlob = blob; previewUrl = URL.createObjectURL(blob);
        preview.querySelector('img').src = previewUrl; preview.hidden = false;
        form.querySelector('[data-upload-symbol]').hidden = true;
        form.querySelector('[data-upload-empty]').hidden = true;
        progress.textContent = root.dataset.prepared;
      }).catch(e => {
        if (current !== selection) return;
        fileInput.setCustomValidity(e.message); showError(e.message); progress.textContent = '';
      });
    });
    const call = async (url, options) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 45000);
      try {
        const response = await fetch(url, {...options, signal:controller.signal, credentials:'omit'});
        const result = await response.json();
        if (!response.ok) throw Object.assign(new Error(result.error || 'REQUEST_FAILED'), {status:response.status});
        return result;
      } finally { clearTimeout(timer); }
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      if (processing) await processing;
      if (busy) return;
      if (!form.reportValidity()) return;
      if (!imageBlob) { showError(root.dataset.photoError); fileInput.focus(); return; }
      busy = true; button.disabled = true; button.textContent = root.dataset.submitting; error.hidden = true;
      form.setAttribute('aria-busy','true');
      try {
        const endpoint = new URL(root.dataset.endpoint);
        if (endpoint.origin !== 'https://jmucqrtmvsafmesixcmd.supabase.co' || endpoint.pathname.replace(/\/$/,'') !== '/functions/v1/wallanthem-photo-intake') throw new Error('INVALID_ENDPOINT');
        const base = endpoint.origin + endpoint.pathname.replace(/\/$/,'');
        if (!session) session = await call(base+'/session',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({website:form.elements.website.value})});
        const data = new FormData(form);
        data.set('photo',imageBlob,'wallanthem-setup.jpg');
        data.set('instagram',data.get('instagram').trim().replace(/^@/,''));
        const result = await call(base+'/submit',{method:'POST',headers:{Authorization:'Bearer '+session.token,'X-Submission-Id':session.id},body:data});
        if (!result.submitted || !result.reference) throw new Error('INVALID_RESPONSE');
        root.querySelector('[data-reference]').textContent = result.reference;
        form.hidden = true;
        const success = root.querySelector('[data-form-success]'); success.hidden = false; success.focus();
        form.reset(); imageBlob = null; clearPreview();
      } catch (e) {
        const messages = {SUBMISSION_LIMIT:root.dataset.rateError,INVALID_FIELDS:root.dataset.fieldError,CONSENT_REQUIRED:root.dataset.fieldError,INVALID_IMAGE:root.dataset.fileError,IMAGE_DIMENSIONS:root.dataset.sizeError,FILE_TOO_LARGE:root.dataset.fileError,ALREADY_SUBMITTED:root.dataset.duplicateError,UNAUTHORIZED:root.dataset.retryError};
        showError(messages[e.message] || root.dataset.error);
        if (e.status === 401) session = null;
        error.scrollIntoView({block:'nearest',behavior:'smooth'});
      } finally { busy = false; button.disabled = false; button.innerHTML = buttonText; form.removeAttribute('aria-busy'); }
    });
    form.elements.credit.addEventListener('change', () => {
      form.elements.instagram.required = form.elements.credit.checked;
    });
  };
  document.querySelectorAll('[data-wa-photos]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-wa-photos]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-project-tribute"] && !Shopify.designMode) return;
  try {
    
class WaTributeDesigner extends HTMLElement {
  connectedCallback() {
    if(this.started)return;this.started=true;
    this.form=this.querySelector('form');this.canvas=this.querySelector('canvas');this.ctx=this.canvas.getContext('2d');this.photo=null;this.logo=null;this.background=null;this.fontReady=false;this.busy=false;this.reviewing=false;this.zoom=1;this.panX=.5;this.panY=.5;this.loadRevision=0;this.logoRevision=0;this.pendingPhoto=false;this.pendingLogo=false;
    this.fields=['project','location','date','role','recipient'];
    this.fields.forEach(key=>this.el(key).addEventListener('input',()=>{this.el(key).setCustomValidity('');this.edit();}));
    this.initAI();
    this.el('photo').addEventListener('change',()=>this.readPhoto());
    this.el('logo').addEventListener('change',()=>this.readLogo());
    for(const key of ['zoom','panX','panY'])this.el(key).addEventListener('input',()=>{this[key]=Number(this.el(key).value);this.edit();});
    this.el('reset').addEventListener('click',()=>{this.zoom=1;this.panX=this.panY=.5;this.syncControls();this.edit();});
    this.el('removeLogo').addEventListener('click',()=>{this.logoRevision++;this.pendingLogo=false;this.logo=null;this.el('logo').value='';this.edit();this.updateReview();});
    this.el('review').addEventListener('click',()=>this.review());
    this.el('back').addEventListener('click',()=>this.edit());
    this.el('confirm').addEventListener('change',()=>this.updateCheckout());
    this.el('mockupView').addEventListener('click',()=>this.setReviewView('mockup'));
    this.el('flatView').addEventListener('click',()=>this.setReviewView('flat'));
    this.form.addEventListener('submit',event=>this.submit(event));
    this.canvas.addEventListener('pointerdown',e=>this.dragStart(e));
    this.canvas.addEventListener('pointermove',e=>this.dragMove(e));
    for(const name of ['pointerup','pointercancel','lostpointercapture'])this.canvas.addEventListener(name,()=>{this.drag=null;});
    this.el('review').disabled=true;
    this.mockupPromise=this.dataset.mockup?this.loadImage(this.dataset.mockup,true).catch(()=>null):Promise.resolve(null);
    Promise.all([this.loadImage(this.dataset.background,true),document.fonts.load('bold 48px WallTribute')]).then(([image])=>{this.background=image;this.fontReady=true;this.draw();this.updateReview();this.say('');}).catch(()=>this.say(this.dataset.loadError));
    window.addEventListener('pageshow',()=>{this.busy=false;this.inert=false;this.updateReview();this.updateCheckout();});
    this.draw();
  }
  initAI(){
    this.aiEnabled=this.dataset.aiEnabled==='true';this.aiStyle='original_photo';this.aiRevision=0;
    if(!this.aiEnabled)return;
    this.el('styleFaithful').addEventListener('change',()=>this.chooseStyle('faithful_engraving'));
    this.el('styleOriginal').addEventListener('change',()=>this.chooseStyle('original_photo'));
    this.el('styleIllustration').addEventListener('change',()=>this.chooseStyle('architectural_engraving'));
    this.el('aiConsent').addEventListener('change',()=>this.updateAI());
    this.el('generate').addEventListener('click',()=>this.generateAI());
  }
  aiNeedsResult(){return this.aiEnabled&&((this.aiStyle==='architectural_engraving'&&!this.aiImage)||(this.aiStyle==='faithful_engraving'&&(!this.faithfulImage||this.faithfulPending)));}
  updateAI(){
    if(!this.aiEnabled)return;
    this.el('generate').disabled=!this.originalPhoto||!this.el('aiConsent').checked||this.aiPending||!!this.aiImage;
    this.el('generate').textContent=this.aiPending?this.dataset.illustrationCreating:this.aiImage?this.dataset.illustrationReady:this.dataset.illustrationCreate;
  }
  resetAI(){
    this.aiRevision++;this.faithfulPending=false;this.faithfulImage=null;this.faithfulBlob=null;this.aiPending=false;this.aiSession=null;this.aiImage=null;this.aiBlob=null;this.approvalId=null;this.aiStyle='original_photo';
    if(!this.aiEnabled)return;
    this.el('styleFaithful').checked=false;this.el('faithfulStatus').hidden=true;this.el('faithfulStatus').textContent='';this.el('styleOriginal').checked=true;this.el('styleIllustration').checked=false;this.el('aiConsent').checked=false;
    this.el('aiOptions').hidden=true;this.el('aiStatus').textContent='';this.el('imageStyle').value='Original photo';
    this.el('approvalReference').value='';this.el('selectedArtwork').value='';this.updateAI();
  }
  chooseStyle(style){
    if(this.busy)return;
    this.aiStyle=style;this.approvalId=null;
    this.photo=style==='architectural_engraving'&&this.aiImage?this.aiImage:style==='faithful_engraving'&&this.faithfulImage?this.faithfulImage:this.originalPhoto;
    this.el('aiOptions').hidden=style!=='architectural_engraving';
    this.el('faithfulStatus').hidden=style!=='faithful_engraving';
    this.el('imageStyle').value=style==='original_photo'?'Original photo':style==='faithful_engraving'?'Faithful engraving':'Architectural illustration';
    this.el('selectedArtwork').value='';this.el('approvalReference').value='';
    this.zoom=1;this.panX=this.panY=.5;this.syncControls();this.edit();this.updateAI();this.updateReview();
    if(style==='faithful_engraving')this.createFaithful();
  }
  async createFaithful(){
    const status=this.el('faithfulStatus');
    if(!this.originalPhoto){status.textContent='Upload a project photo first, then select Faithful engraving.';return;}
    if(this.faithfulImage){status.textContent='Your photo with an engraving finish. Objects and perspective are preserved; adjust the crop to choose what appears on the banner.';return;}
    if(this.faithfulPending)return;
    const rev=this.aiRevision;this.faithfulPending=true;this.updateReview();status.textContent='Applying an engraving finish to your photo…';
    try{
      const source=this.originalPhoto,scale=Math.min(1,3840/source.naturalWidth,3840/source.naturalHeight,Math.sqrt(6000000/(source.naturalWidth*source.naturalHeight)));
      const c=document.createElement('canvas');c.width=Math.max(1,Math.round(source.naturalWidth*scale));c.height=Math.max(1,Math.round(source.naturalHeight*scale));
      const ctx=c.getContext('2d',{willReadFrequently:true});ctx.fillStyle='#ffffff';ctx.fillRect(0,0,c.width,c.height);ctx.drawImage(source,0,0,c.width,c.height);
      const pixels=ctx.getImageData(0,0,c.width,c.height),data=pixels.data,w=c.width,h=c.height,gray=new Float32Array(w*h);
      for(let i=0;i<gray.length;i++)gray[i]=(data[i*4]*.2126+data[i*4+1]*.7152+data[i*4+2]*.0722)/255;
      for(let y=0;y<h;y++){
        if(y%64===0){await new Promise(r=>setTimeout(r,0));if(rev!==this.aiRevision)return;}
        for(let x=0;x<w;x++){
          const i=y*w+x,l=gray[y*w+Math.max(0,x-1)],r=gray[y*w+Math.min(w-1,x+1)],u=gray[Math.max(0,y-1)*w+x],d=gray[Math.min(h-1,y+1)*w+x];
          const edge=Math.min(1,Math.hypot(r-l,d-u)*2.1),shade=1-gray[i];
          const hatch=((x+y)%6===0?1:0)*(shade>.24?.13:0)+((x-y+w)%7===0?1:0)*(shade>.58?.13:0);
          const ink=Math.min(.96,Math.max(0,shade*.72+edge*.53+hatch));
          data[i*4]=Math.round(245+(30-245)*ink);data[i*4+1]=Math.round(236+(60-236)*ink);data[i*4+2]=Math.round(214+(45-214)*ink);
        }
      }
      ctx.putImageData(pixels,0,0);const blob=await this.blob(c),url=URL.createObjectURL(blob);let result;
      try{result=await this.loadImage(url);}finally{URL.revokeObjectURL(url);}
      if(rev!==this.aiRevision)return;
      this.faithfulBlob=blob;this.faithfulImage=result;
      if(this.aiStyle==='faithful_engraving'){this.photo=result;this.syncControls();this.edit();}
      status.textContent='Your photo with an engraving finish. Objects and perspective are preserved; adjust the crop to choose what appears on the banner.';
    }catch{if(rev===this.aiRevision)status.textContent='The finish could not be applied. Select Original photo or try Faithful engraving again.';}
    finally{if(rev===this.aiRevision){this.faithfulPending=false;this.updateReview();}}
  }
  async aiRequest(route,body,session=this.aiSession){
    const binary=body instanceof Blob,headers={'Content-Type':binary?'image/jpeg':'application/json'};
    if(session){headers.Authorization='Bearer '+session.token;headers['X-Design-Id']=session.id;}
    const response=await fetch(this.dataset.aiEndpoint+'/'+route,{method:'POST',headers,body:binary?body:JSON.stringify(body||{}),signal:AbortSignal.timeout(30000)});
    const data=await response.json();if(!response.ok)throw Error(data.error||'SERVICE_UNAVAILABLE');return data;
  }
  async canonicalPhoto(image,maxEdge=3840,maxPixels=6000000){
    const scale=Math.min(1,maxEdge/image.naturalWidth,maxEdge/image.naturalHeight,Math.sqrt(maxPixels/(image.naturalWidth*image.naturalHeight)));
    const c=document.createElement('canvas');c.width=Math.max(64,Math.round(image.naturalWidth*scale));c.height=Math.max(64,Math.round(image.naturalHeight*scale));
    const ctx=c.getContext('2d');ctx.fillStyle='#ffffff';ctx.fillRect(0,0,c.width,c.height);ctx.drawImage(image,0,0,c.width,c.height);return this.blob(c);
  }
  async generateAI(){
    if(this.aiPending||this.aiImage||!this.originalPhoto||!this.el('aiConsent').checked)return;
    const rev=this.aiRevision;this.aiPending=true;this.edit();this.updateAI();this.updateReview();
    const status=this.el('aiStatus');status.textContent='Preparing your project photo…';
    try{
      const source=await this.canonicalPhoto(this.originalPhoto);if(rev!==this.aiRevision)return;
      if(!this.aiSession){const session=await this.aiRequest('session',{photo_processing_consent:true},null);if(rev!==this.aiRevision)return;await this.aiRequest('upload',source,session);if(rev!==this.aiRevision)return;this.aiSession=session;}
      if(rev!==this.aiRevision)return;
      const session=this.aiSession;
      await this.aiRequest('generate',{photo_processing_consent:true},session);
      status.textContent=this.dataset.illustrationWorking;
      const deadline=Date.now()+160000;
      while(Date.now()<deadline){
        await new Promise(r=>setTimeout(r,2500));if(rev!==this.aiRevision)return;
        const job=await this.aiRequest('status',{},session);
        if(job.status==='failed')throw Error(job.error||'CONVERSION_FAILED');
        if(job.status==='completed'){
          const result=await fetch(job.image_url,{signal:AbortSignal.timeout(20000)});if(!result.ok)throw Error('IMAGE_UNAVAILABLE');
          const blob=await result.blob(),url=URL.createObjectURL(blob);let image;
          try{image=await this.loadImage(url);}finally{URL.revokeObjectURL(url);}
          if(rev!==this.aiRevision)return;
          this.aiBlob=blob;this.aiImage=image;
          if(this.aiStyle==='architectural_engraving'){this.photo=image;this.zoom=1;this.panX=this.panY=.5;this.syncControls();this.edit();}
          status.textContent=this.dataset.illustrationCompleted;return;
        }
      }
      throw Error('CONVERSION_TIMEOUT');
    }catch(error){
      if(rev!==this.aiRevision)return;
      const messages={GENERATION_LIMIT:'The illustration limit has been reached. You can still order with your original photo.',SESSION_LIMIT:'Please try again later, or continue with your original photo.',GENERATION_DISABLED:'Illustrations are temporarily unavailable. Your original photo still works.',PROVIDER_QUOTA:'Illustrations are temporarily unavailable. Your original photo still works.',CONSENT_REQUIRED:'Please agree to photo processing before creating an illustration.'};
      status.textContent=messages[error.message]||'We could not finish this illustration. Your original photo is safe. Try again later or choose Original photo.';
    }finally{if(rev===this.aiRevision){this.aiPending=false;this.updateAI();this.updateReview();}}
  }
  async base64Blob(blob){return new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result.split(',')[1]);r.onerror=reject;r.readAsDataURL(blob);});}
  async saveAIApproval(proofBlob){
    if(!this.aiSession||!this.aiBlob||!this.aiImage)throw Error('Your illustration is not ready. Return to the editor and try again.');
    const configuration={...this.values(),zoom:this.zoom,panX:this.panX,panY:this.panY,sourceWidth:this.photo.naturalWidth,sourceHeight:this.photo.naturalHeight};
    const logo=this.logo?await this.canonicalPhoto(this.logo,1000,1000000):null;
    const approval=await this.aiRequest('approve',{layout_confirmed:true,image_style:'architectural_engraving',configuration,preview_b64:await this.base64Blob(proofBlob),logo_b64:logo?await this.base64Blob(logo):null});
    this.approvalId=approval.approval_id;this.el('approvalReference').value=this.approvalId;
  }

  el(key){return this.querySelector(`[data-field="${key}"]`);}
  say(message){this.el('message').textContent=message;}
  loadImage(src,cors=false){return new Promise((resolve,reject)=>{const i=new Image();if(cors)i.crossOrigin='anonymous';i.onload=()=>resolve(i);i.onerror=reject;i.src=src;});}
  async openFile(input){const f=input.files[0];if(!f)return null;if(!['image/jpeg','image/png','image/webp'].includes(f.type)||f.size>10*1024*1024)throw Error(this.dataset.fileError);const url=URL.createObjectURL(f);try{const image=await this.loadImage(url);if(image.naturalWidth*image.naturalHeight>50000000)throw Error(this.dataset.fileError);return image;}finally{URL.revokeObjectURL(url);}}
  updateReview(){this.el('review').disabled=!this.fontReady||this.pendingPhoto||this.pendingLogo||this.busy||(this.aiPending&&this.aiStyle==='architectural_engraving')||this.aiNeedsResult();}
  async readPhoto(){this.resetAI();const rev=++this.loadRevision;this.photo=null;this.originalPhoto=null;this.pendingPhoto=true;this.edit();this.updateReview();try{const image=await this.openFile(this.el('photo'));if(rev!==this.loadRevision)return;this.photo=image;this.originalPhoto=image;this.updateAI();this.zoom=1;this.panX=this.panY=.5;this.syncControls();this.say('');}catch(e){if(rev!==this.loadRevision)return;this.el('photo').value='';this.say(e.message);}finally{if(rev===this.loadRevision){this.pendingPhoto=false;this.updateReview();this.edit();}}}
  async readLogo(){const rev=++this.logoRevision;this.logo=null;this.pendingLogo=true;this.edit();this.updateReview();try{const image=await this.openFile(this.el('logo'));if(rev!==this.logoRevision)return;this.logo=image;this.say('');}catch(e){if(rev!==this.logoRevision)return;this.el('logo').value='';this.say(e.message);}finally{if(rev===this.logoRevision){this.pendingLogo=false;this.updateReview();this.edit();}}}
  syncControls(){for(const key of ['zoom','panX','panY'])this.el(key).value=this[key];}
  edit(){if(this.busy)return;this.reviewing=false;this.el('confirm').checked=false;this.el('reviewPanel').hidden=true;this.el('editor').hidden=false;this.el('step').textContent=this.dataset.editStep;this.el('viewControls').hidden=true;this.el('mockupMain').hidden=true;this.el('mockupNote').hidden=true;this.canvas.hidden=false;this.updateCheckout();this.draw();}
  values(){return Object.fromEntries(this.fields.map(k=>[k,this.el(k).value.trim().toUpperCase()]));}
  geometry(){if(!this.photo)return null;const scale=Math.max(1460/this.photo.naturalWidth,385/this.photo.naturalHeight)*this.zoom;const width=this.photo.naturalWidth*scale,height=this.photo.naturalHeight*scale;return {scale,width,height,x:64-(width-1460)*this.panX,y:330-(height-385)*this.panY};}
  draw(){const c=this.ctx,v=this.values();c.clearRect(0,0,1588,991);c.fillStyle='#ebdfbe';c.fillRect(0,0,1588,991);if(this.background)c.drawImage(this.background,0,0,1588,991);
    if(this.photo){const g=this.geometry();c.save();c.beginPath();c.rect(64,330,1460,385);c.clip();c.drawImage(this.photo,g.x,g.y,g.width,g.height);c.restore();this.el('panX').disabled=g.width<=1460.01;this.el('panY').disabled=g.height<=385.01;this.el('quality').textContent=Math.min(1460/g.scale,385/g.scale)<500?this.dataset.qualityWarning:'';}
    else{c.fillStyle='#17362b';c.fillRect(64,330,1460,385);c.fillStyle='#eadcba';c.font='32px sans-serif';c.textAlign='center';c.fillText(this.dataset.photoPlaceholder,794,538);this.el('quality').textContent='';}
    c.strokeStyle='#876534';c.lineWidth=2;c.beginPath();c.moveTo(350,324);c.lineTo(1238,324);c.stroke();
    this.text('BUILT ON OUR WORD',141,48,1080,6);this.text(v.project||this.dataset.projectPlaceholder,252,98,1340,1);this.text(v.location||this.dataset.locationPlaceholder,308,35,1130,5);this.text('PROJECT COMPLETION • '+(v.date||'2026'),761,34,1000,3);this.text(v.role||'SUPERINTENDENT',808,29,900,5);this.text(v.recipient||this.dataset.namePlaceholder,889,83,990,1);
    if(this.logo){const s=Math.min(160/this.logo.naturalWidth,100/this.logo.naturalHeight);c.drawImage(this.logo,1400-this.logo.naturalWidth*s/2,837-this.logo.naturalHeight*s/2,this.logo.naturalWidth*s,this.logo.naturalHeight*s);}
    this.el('cropControls').hidden=!this.photo;this.canvas.classList.toggle('has-photo',!!this.photo&&!this.reviewing);this.el('zoomValue').textContent=this.zoom.toFixed(2)+'×';
  }
  text(value,y,size,maxWidth,spacing){const c=this.ctx;let f=Math.min(size,(maxWidth-value.length*4)/Math.max(value.length,1)/.72);c.font=`bold ${Math.max(12,f)}px WallTribute,Georgia,serif`;if('letterSpacing' in c)c.letterSpacing=spacing+'px';while(c.measureText(value).width>maxWidth&&f>12){f-=1;c.font=`bold ${f}px WallTribute,Georgia,serif`;}c.fillStyle='#112a20';c.textAlign='center';c.fillText(value,794,y,maxWidth);if('letterSpacing' in c)c.letterSpacing='0px';}
  pointer(e){const b=this.canvas.getBoundingClientRect();return {x:(e.clientX-b.left)*1588/b.width,y:(e.clientY-b.top)*991/b.height};}
  dragStart(e){if(!this.photo||this.reviewing||this.busy)return;const p=this.pointer(e);if(p.x<64||p.x>1524||p.y<330||p.y>715)return;this.drag={...p,panX:this.panX,panY:this.panY};this.canvas.setPointerCapture(e.pointerId);}
  dragMove(e){if(!this.drag)return;const p=this.pointer(e),g=this.geometry(),clamp=n=>Math.max(0,Math.min(1,n));this.panX=g.width>1460?clamp(this.drag.panX-(p.x-this.drag.x)/(g.width-1460)):.5;this.panY=g.height>385?clamp(this.drag.panY-(p.y-this.drag.y)/(g.height-385)):.5;this.syncControls();this.el('confirm').checked=false;this.draw();}
  makeMockup(base){
    const mock=document.createElement('canvas');
    const scaleY=(1130*34.5/56)/655;
    mock.width=1448;mock.height=Math.round(1086*scaleY);
    const c=mock.getContext('2d');
    c.drawImage(base,0,0,mock.width,mock.height);
    c.save();c.beginPath();c.rect(161,201*scaleY,1128,653*scaleY);c.clip();
    c.globalCompositeOperation='multiply';
    c.drawImage(this.canvas,160,200*scaleY,1130,655*scaleY);
    c.restore();
    for(const cy of [222,834]){
      c.save();c.beginPath();c.ellipse(183.5,cy*scaleY,12,12*scaleY,0,0,Math.PI*2);c.clip();
      c.drawImage(base,0,0,mock.width,mock.height);c.restore();
    }
    return mock.toDataURL('image/jpeg',.95);
  }
  setReviewView(view){
    const useMockup=view==='mockup'&&!!this.mockupURL;
    this.canvas.hidden=useMockup;this.el('mockupMain').hidden=!useMockup;
    this.el('reviewImage').src=useMockup?this.mockupURL:this.flatURL;
    this.el('mockupView').setAttribute('aria-pressed',String(useMockup));
    this.el('flatView').setAttribute('aria-pressed',String(!useMockup));
  }
  async review(){
    this.el('confirm').required=false;for(const key of this.fields){const input=this.el(key);input.setCustomValidity(input.value.trim()?'':this.dataset.requiredText);}if(!this.form.reportValidity())return;
    if(this.pendingPhoto||this.pendingLogo)return;
    if((this.aiPending&&this.aiStyle==='architectural_engraving')||this.aiNeedsResult()||!this.photo||!this.background||!this.fontReady){this.say(this.dataset.fileError);return;}
    this.el('review').disabled=true;
    try{
      const base=await this.mockupPromise;this.draw();this.flatURL=this.canvas.toDataURL('image/jpeg',.94);
      this.mockupURL=base?this.makeMockup(base):null;
      if(this.mockupURL)this.el('mockupMain').src=this.mockupURL;
      this.reviewing=true;this.el('editor').hidden=true;this.el('reviewPanel').hidden=false;
      this.el('step').textContent=this.dataset.reviewStep;this.el('confirm').required=true;
      this.el('summary').textContent=this.fields.map(k=>this.el(k).value.trim()).join(' · ');
      this.el('viewControls').hidden=false;this.el('mockupView').disabled=!this.mockupURL;this.el('mockupNote').hidden=false;
      this.say(base?'':this.dataset.mockupUnavailable);this.setReviewView('mockup');this.updateCheckout();this.el('reviewTitle').focus();this.draw();
    }catch{this.say(this.dataset.exportError);}finally{this.el('review').disabled=false;}
  }
  updateCheckout(){this.el('checkout').disabled=this.busy||!this.reviewing||!this.el('confirm').checked||this.dataset.ordering!=='true';}
  async blob(canvas){return new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(Error(this.dataset.exportError)),'image/jpeg',.95));}
  async submit(e){e.preventDefault();if(this.busy||!this.reviewing||!this.el('confirm').checked||this.dataset.ordering!=='true')return;this.busy=true;this.inert=true;this.updateCheckout();this.say(this.dataset.preparing);try{
      this.draw();const crop=document.createElement('canvas');crop.width=2920;crop.height=770;const cc=crop.getContext('2d'),g=this.geometry();cc.drawImage(this.photo,(g.x-64)*2,(g.y-330)*2,g.width*2,g.height*2);
      const [proofBlob,cropBlob]=await Promise.all([this.blob(this.canvas),this.blob(crop)]);const ref=crypto.randomUUID();
      if(this.aiStyle==='architectural_engraving'){await this.saveAIApproval(proofBlob);const dt=new DataTransfer();dt.items.add(new File([this.aiBlob],`wallanthem-${this.approvalId}-selected-artwork.jpg`,{type:'image/jpeg'}));this.el('selectedArtwork').files=dt.files;}
      if(this.aiStyle==='faithful_engraving'){if(!this.faithfulBlob)throw Error('Your engraving is not ready.');const dt=new DataTransfer();dt.items.add(new File([this.faithfulBlob],`wallanthem-${ref}-faithful-engraving.jpg`,{type:'image/jpeg'}));this.el('selectedArtwork').files=dt.files;}
      for(const [key,blob,suffix] of [['proofFile',proofBlob,'design-preview'],['cropFile',cropBlob,'project-crop']]){const dt=new DataTransfer();dt.items.add(new File([blob],`wallanthem-${ref}-${suffix}.jpg`,{type:'image/jpeg'}));this.el(key).files=dt.files;}
      this.el('configuration').value=JSON.stringify({version:'wa-project-tribute-customer-v2',reference:ref,...this.values(),zoom:this.zoom,panX:this.panX,panY:this.panY,sourceWidth:this.photo.naturalWidth,sourceHeight:this.photo.naturalHeight,imageStyle:this.aiStyle||'original_photo',approvalId:this.approvalId||null,customerConfirmedAt:new Date().toISOString(),approval:'layout-confirmed; production-proof-pending'});
      HTMLFormElement.prototype.submit.call(this.form);
    }catch(error){this.busy=false;this.inert=false;this.updateCheckout();this.say(/^[A-Z_]+$/.test(error.message||'')?'We could not save your approved design. Please try again; your preview is unchanged.':error.message||this.dataset.exportError);}}
}
if(!customElements.get('wa-tribute-designer'))customElements.define('wa-tribute-designer',WaTributeDesigner);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-sticky-cart"]) return;
  try {
    
  if (!customElements.get('wa-sticky-cart')) {
    customElements.define('wa-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.link = this.querySelector('a');
        this.countElement = this.querySelector('[data-wa-cart-count]');
        this.status = this.querySelector('[data-wa-cart-status]');
        this.statusTemplate = this.querySelector('[data-wa-cart-status-template]').textContent;
        this.count = Number(this.dataset.count) || 0;
        const on = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal: this.abort.signal });
        on(document, 'click', event => {
          if (!event.target.closest('.wa-sticky-cart__link')) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const drawer = document.querySelector('cart-drawer-component');
          if (typeof drawer?.open !== 'function') return;
          event.preventDefault();
          drawer.open();
          this.scheduleLayout();
        });
        on(document, 'cart:update', () => this.queueRefresh());
        on(document, 'discount:update', () => this.queueRefresh());
        on(window, 'pageshow', event => { if (event.persisted) this.queueRefresh(); this.scheduleLayout(); });
        on(window, 'focus', () => this.queueRefresh());
        on(window, 'resize', () => this.scheduleLayout(), { passive: true });
        on(document, 'scroll', () => this.scheduleLayout(), { passive: true });
        on(document, 'focusin', () => this.scheduleLayout());
        on(document, 'focusout', () => this.scheduleLayout());
        this.observer = new MutationObserver(() => this.scheduleLayout());
        this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'data-stuck', 'aria-expanded'] });
        this.renderCount(false);
        this.queueRefresh();
      }
      queueRefresh() {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 80);
      }
      async refresh() {
        if (this.loading) { this.refreshAgain = true; return; }
        this.loading = true;
        try {
          const response = await fetch(this.dataset.root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: this.abort.signal });
          if (!response.ok) return;
          const cart = await response.json();
          if (Number.isInteger(cart.item_count) && cart.item_count >= 0) {
            const changed = this.count !== cart.item_count;
            this.count = cart.item_count;
            this.renderCount(changed);
          }
        } catch {} finally {
          this.loading = false;
          if (this.refreshAgain && this.isConnected) { this.refreshAgain = false; this.queueRefresh(); }
        }
      }
      renderCount(announce) {
        this.countElement.textContent = String(this.count);
        if (announce) this.status.textContent = this.statusTemplate.replace('[count]', String(this.count));
        if (document.querySelector('cart-drawer-component')) this.link.setAttribute('aria-haspopup', 'dialog');
        this.scheduleLayout();
      }
      visible(element) {
        if (!element || element.closest('[hidden], [aria-hidden="true"]')) return false;
        const rect = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
      }
      scheduleLayout() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.layout(); });
      }
      layout() {
        const blocked = [...document.querySelectorAll('dialog[open], [aria-modal="true"], #shopify-pc__banner, #shopify-pc__prefs, [data-cookie-banner]')].some(element => this.visible(element));
        const typing = window.matchMedia('(max-width: 649px)').matches && document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const bar = document.querySelector('sticky-add-to-cart[data-variant-available="true"] [data-stuck="true"]');
        const ironBar = document.querySelector('wa-iron-live .wi__action');
        const ironBarActive = this.visible(ironBar) && getComputedStyle(ironBar).position === 'fixed';
        const barActive = Boolean(bar) || ironBarActive;
        document.body.classList.toggle('wa-product-bar-visible', barActive);
        document.body.classList.toggle('wa-cart-overlay-open', blocked);
        if (bar) {
          let inline = bar.querySelector('.wa-sticky-cart__inline');
          if (!inline) {
            inline = this.link.cloneNode(true);
            inline.classList.add('wa-sticky-cart__inline');
            inline.style.removeProperty('bottom');
            bar.append(inline);
          }
          const badge = inline.querySelector('[data-wa-cart-count]');
          if (badge.textContent !== String(this.count)) badge.textContent = String(this.count);
          const inlineHidden = this.count === 0 || blocked || typing;
          if (inline.hidden !== inlineHidden) inline.hidden = inlineHidden;
        }
        const hidden = this.count === 0 || blocked || typing || (barActive && window.matchMedia('(max-width: 749px)').matches);
        if (this.link.hidden !== hidden) this.link.hidden = hidden;
        if (hidden) return;
        this.link.style.removeProperty('bottom');
        let rect = this.link.getBoundingClientRect();
        let bottom = window.innerHeight - rect.bottom;
        const obstacleElements = [...document.querySelectorAll('sticky-add-to-cart [data-stuck="true"], .wa-welcome__reopen')];
        if (ironBarActive) obstacleElements.push(ironBar);
        const obstacles = obstacleElements.filter(element => this.visible(element)).map(element => element.getBoundingClientRect()).sort((a, b) => b.top - a.top);
        for (const obstacle of obstacles) {
          if (rect.right > obstacle.left - 8 && rect.left < obstacle.right + 8 && rect.bottom > obstacle.top - 12 && rect.top < obstacle.bottom + 12) {
            bottom = Math.max(bottom, window.innerHeight - obstacle.top + 12);
            this.link.style.bottom = bottom + 'px';
            rect = this.link.getBoundingClientRect();
          }
        }
      }
      disconnectedCallback() {
        document.body.classList.remove('wa-product-bar-visible', 'wa-cart-overlay-open');
        document.querySelectorAll('.wa-sticky-cart__inline').forEach(link => link.remove());
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        clearTimeout(this.refreshTimer);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wa-welcome-popup"]) return;
  try {
    
  if (!customElements.get('wa-welcome-popup')) {
    customElements.define('wa-welcome-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.reopen = this.querySelector('[data-wa-reopen]');
        if (!this.dialog?.showModal || !this.form) return;
        this.abort = new AbortController();
        this.signal = this.abort.signal;
        this.memory = {};
        this.keys = { dismissed: 'wa_welcome_dismissed_v1', joined: 'wa_welcome_joined_v1', pending: 'wa_welcome_pending_v1', seen: 'wa_welcome_seen_v1', offer: 'wa_welcome_offer_v1' };
        this.engaged = false;
        this.ready = false;
        this.opened = false;
        this.done = false;
        this.returnFocus = null;
        this.excluded = this.dataset.excluded === 'true';
        this.editor = this.dataset.designMode === 'true';
        this.startScroll = window.scrollY;
        this.mobile = window.matchMedia('(max-width: 649px), (pointer: coarse)').matches;
        const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: this.signal });
        this.querySelectorAll('[data-wa-close]').forEach(button => on(button, 'click', () => this.dismiss()));
        on(this.dialog, 'cancel', event => { event.preventDefault(); this.dismiss(); });
        on(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
        });
        on(this.reopen, 'click', () => this.open(true));
        on(this.querySelector('[data-wa-retry]'), 'click', () => {
          this.done = false;
          this.removeSession(this.keys.offer);
          this.querySelector('[data-wa-success]').hidden = true;
          this.querySelector('[data-wa-entry]').hidden = false;
          this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        });
        on(document, 'submit', event => {
          if (event.target === this.form) {
            this.setSession(this.keys.pending, String(Date.now()));
          } else {
            this.removeSession(this.keys.pending);
          }
        }, { capture: true });
        on(document, 'scroll', () => {
          if (Math.abs(window.scrollY - this.startScroll) > 30) this.engaged = true;
          this.tryOpen();
        }, { passive: true });
        on(document, 'pointerup', event => {
          if (!this.contains(event.target)) this.engaged = true;
          this.scheduleAttempt();
        }, { passive: true });
        on(document, 'focusout', () => this.scheduleAttempt());
        on(document, 'visibilitychange', () => this.tryOpen());
        on(document, 'visitorConsentCollected', () => this.syncPreferences());
        on(document, 'shopify:section:select', event => { if (this.editor && event.target.contains(this)) this.open(true); });
        this.observer = new MutationObserver(() => this.scheduleAttempt());
        this.observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'hidden', 'aria-hidden'] });
        if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
              if (!error && this.isConnected) this.syncPreferences();
            });
          } catch {}
        }
        this.prepareApplyLink();
        const ownedReturn = window.location.hash === '#' + this.form.id;
        const pendingAge = Date.now() - Number(this.getSession(this.keys.pending) || 0);
        const recentSubmission = !!this.getSession(this.keys.pending) && pendingAge >= 0 && pendingAge < 30 * 60 * 1000;
        const returnTarget = document.getElementById(window.location.hash.slice(1));
        const otherFormReturn = returnTarget?.matches('form') && returnTarget !== this.form;
        const popupReturn = ownedReturn || (recentSubmission && !otherFormReturn);
        const confirmed = this.querySelector('[data-wa-success]').dataset.confirmed === 'true';
        if (!popupReturn) this.querySelector('input[type="email"]')?.removeAttribute('aria-invalid');
        if (popupReturn && this.querySelector('[data-wa-error]')) {
          this.querySelector('[data-wa-error]').hidden = false;
          this.feedback = true;
          this.ready = true;
          this.removeSession(this.keys.pending);
          this.tryOpen();
        } else if (popupReturn && (confirmed || recentSubmission)) {
          this.showOffer(confirmed);
          this.removeSession(this.keys.pending);
          this.feedback = true;
          this.ready = true;
          this.tryOpen();
        } else if (confirmed) {
          this.removeSession(this.keys.pending);
          this.setSession(this.keys.joined, String(Date.now()));
          this.setDurable(this.keys.joined, String(Date.now()));
          this.updatePill();
        } else {
          this.removeSession(this.keys.pending);
          const savedOffer = this.getSession(this.keys.offer);
          if (savedOffer === 'confirmed' || savedOffer === 'pending') this.showOffer(savedOffer === 'confirmed');
          const wait = Math.max(5, Number(this.dataset.delay) || 8) * 1000;
          this.delayTimer = window.setTimeout(() => { this.ready = true; this.tryOpen(); }, wait);
          this.updatePill();
        }
      }
      showOffer(confirmed) {
        this.done = true;
        this.querySelector('[data-wa-entry]').hidden = true;
        this.querySelector('[data-wa-success]').hidden = false;
        this.querySelectorAll('[data-wa-confirmed-copy]').forEach(element => { element.hidden = !confirmed; });
        this.querySelectorAll('[data-wa-pending-copy]').forEach(element => { element.hidden = confirmed; });
        this.querySelector('[data-wa-retry]').hidden = confirmed;
        this.setSession(this.keys.offer, confirmed ? 'confirmed' : 'pending');
        if (confirmed) {
          this.setSession(this.keys.joined, String(Date.now()));
          this.setDurable(this.keys.joined, String(Date.now()));
        }
      }
      preferencesAllowed() {
        try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; } catch { return false; }
      }
      syncPreferences() {
        if (this.preferencesAllowed()) {
          [this.keys.dismissed, this.keys.joined].forEach(key => {
            const value = this.getSession(key);
            if (value) this.setDurable(key, value);
          });
        }
        this.scheduleAttempt();
      }
      getSession(key) {
        try { return window.sessionStorage.getItem(key) || this.memory[key] || ''; } catch { return this.memory[key] || ''; }
      }
      setSession(key, value) {
        this.memory[key] = value;
        try { window.sessionStorage.setItem(key, value); } catch {}
      }
      removeSession(key) {
        delete this.memory[key];
        try { window.sessionStorage.removeItem(key); } catch {}
      }
      getDurable(key) {
        if (!this.preferencesAllowed()) return '';
        try { return window.localStorage.getItem(key) || ''; } catch { return ''; }
      }
      setDurable(key, value) {
        if (!this.preferencesAllowed()) return;
        try { window.localStorage.setItem(key, value); } catch {}
      }
      ageWithin(key, days) {
        const timestamp = Math.max(Number(this.getSession(key) || 0), Number(this.getDurable(key) || 0));
        return timestamp > 0 && Date.now() - timestamp < days * 86400000;
      }
      isVisible(element) {
        return !this.contains(element) && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[hidden], [aria-hidden="true"]');
      }
      blocked() {
        if (document.visibilityState !== 'visible') return true;
        const active = document.activeElement;
        if (!this.contains(active) && active?.matches('input, textarea, select, [contenteditable="true"]')) return true;
        return [...document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], cart-drawer[open], cart-drawer.active, #shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner, [data-cookie-banner]')].some(element => this.isVisible(element));
      }
      updatePill() {
        const suppressed = this.excluded || (!this.done && this.ageWithin(this.keys.joined, 365));
        const hidden = suppressed || this.dialog.open || this.blocked() || !(this.ageWithin(this.keys.dismissed, 7) || this.getSession(this.keys.seen));
        if (this.reopen.hidden !== hidden) this.reopen.hidden = hidden;
      }
      scheduleAttempt() {
        if (this.attemptFrame) return;
        this.attemptFrame = requestAnimationFrame(() => { this.attemptFrame = 0; this.tryOpen(); });
      }
      tryOpen() {
        this.updatePill();
        if (!this.ready || this.dialog.open || this.blocked()) return;
        if (this.feedback) { this.open(true); if (this.dialog.open) this.feedback = false; return; }
        if (this.excluded || this.opened || this.editor || this.done || this.ageWithin(this.keys.joined, 365) || this.ageWithin(this.keys.dismissed, 7) || this.getSession(this.keys.seen)) return;
        if (this.mobile && !this.engaged) return;
        this.open(false);
      }
      open(manual) {
        if (this.dialog.open || this.blocked() || (this.excluded && !this.done && !this.feedback && !this.editor)) return;
        this.returnFocus = document.activeElement;
        this.opened = true;
        this.reopen.hidden = true;
        this.setSession(this.keys.seen, '1');
        this.dialog.showModal();
        if (this.done) this.querySelector('[data-wa-success]')?.focus({ preventScroll: true });
        else if (manual && !this.mobile && !this.querySelector('[data-wa-error]:not([hidden])')) this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        else if (this.querySelector('[data-wa-error]:not([hidden])')) this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      }
      dismiss() {
        this.dialog.close();
        if (!this.done) {
          const now = String(Date.now());
          this.setSession(this.keys.dismissed, now);
          this.setDurable(this.keys.dismissed, now);
        }
        this.updatePill();
        if (this.returnFocus?.isConnected && this.returnFocus !== document.body) this.returnFocus.focus({ preventScroll: true });
      }
      cleanDestination() {
        const destination = new URL(window.location.href);
        ['customer_posted', 'contact_posted', 'form_type', 'utf8'].forEach(key => destination.searchParams.delete(key));
        return destination.pathname + destination.search;
      }
      prepareApplyLink() {
        const link = this.querySelector('[data-wa-apply]');
        if (!link || !this.dataset.code) return;
        link.href = this.dataset.root + 'discount/' + encodeURIComponent(this.dataset.code) + '?redirect=' + encodeURIComponent(this.cleanDestination());
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        clearTimeout(this.delayTimer);
        cancelAnimationFrame(this.attemptFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
